var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelligence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m36.337 19.703 1.897 6.359a3.595 3.595 0 0 1-1.788 4.2l-12.253 6.511a6.789 6.789 0 0 1-6.387 0l-5.496-2.927-4.164-2.21-2.592-1.38a3.595 3.595 0 0 1-1.789-4.188l1.897-6.365h30.675Z",
    fill: "#2980BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m41.565 17.235-19.58 9.248a2.292 2.292 0 0 1-1.971 0L.434 17.235a.731.731 0 0 1 0-1.335l19.58-9.248a2.293 2.293 0 0 1 1.971 0l19.58 9.248a.73.73 0 0 1 0 1.335Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.927 31.704a.724.724 0 0 1-.34-1.364l6.16-3.273-.883-2.987a.726.726 0 0 1 .768-.936.724.724 0 0 1 .62.52l.9 3.016a1.426 1.426 0 0 1-.725 1.666l-6.162 3.274a.725.725 0 0 1-.338.084Z",
    fill: "#B0D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.138 33.225a.724.724 0 0 1-.724-.724v-8.835a2.89 2.89 0 0 1 1.536-2.558l9.71-5.175a.725.725 0 0 1 .68 1.277l-9.71 5.174a1.449 1.449 0 0 0-.768 1.282v8.835a.724.724 0 0 1-.724.724Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.137 30.328a2.172 2.172 0 0 1 2.173 2.173v3.62a.724.724 0 0 1-.725.724H8.69a.724.724 0 0 1-.724-.724v-3.62a2.172 2.172 0 0 1 2.172-2.173Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18.017c1.6 0 2.897-.649 2.897-1.449S22.6 15.12 21 15.12c-1.6 0-2.896.649-2.896 1.448 0 .8 1.296 1.449 2.896 1.449Z",
    fill: "#F3D55B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligence);
export default __webpack_public_path__ + "static/media/intelligence.8364e92dcd8f87875eba38912b7b7100.svg";
export { ForwardRef as ReactComponent };